/**
 * 每小時固定的假人次（55~87）
 * 同一個小時內所有人看到相同值，跨整點才換
 */
export function getHourlyFakeBase(): number {
  const hourSeed = Math.floor(Date.now() / (1000 * 60 * 60));
  const hash = ((hourSeed * 1103515245 + 12345) >>> 0) % 33;
  return 55 + hash; // 55 ~ 87
}
